import axios from 'axios';
import baseUrl from './Base_Url/baseUrl';
import { showToast } from './toastService';
import { getApiErrorMessage, markApiToastShown } from 'utils/apiFeedback';

const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

let isUnauthorizedToastShown = false; // flag to track if the toast has been shown

const resetUnauthorizedToast = () => {
  isUnauthorizedToastShown = false;
};

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { status } = error.response || {};
    const isLoginRequest = error.config?.url?.includes('/auth/login');
    const skipGlobalErrorToast = error.config?.skipGlobalErrorToast;

    if (status === 401 && !isLoginRequest) {
      if (!isUnauthorizedToastShown) {
        isUnauthorizedToastShown = true;
        showToast(getApiErrorMessage(error, 'Unauthorized user. Please login.'));
        markApiToastShown(error);
        localStorage.clear();
        window.location.href = '/auth/sign-in';
        setTimeout(resetUnauthorizedToast, 5000); // e.g., 5 seconds
      }
    } else if (status === 403 && !isLoginRequest) {
      showToast(
        getApiErrorMessage(error, 'You are not allowed to access this page!'),
      );
      markApiToastShown(error);
      window.location.href = '/admin/dashboard';
    } else if (!isLoginRequest && !skipGlobalErrorToast) {
      showToast(getApiErrorMessage(error));
      markApiToastShown(error);
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
